export const wmUtilities = () => {
  const utilities = {
    waitForElementToExist: (selector) => {
      /*
      Implementation:
      ------------------
      wemove.utilities
        .waitForElementToExist("[data-wm-form-field='postal'] .ak-err")
        .then((element) => {
          element.insertAdjacentHTML("beforeend", otherCountryError);
        });
      */
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          subtree: true,
          childList: true,
        });
      });
    },
    isAkFormValid: (akForm) => {
      const fieldsToValidate = [
        ...akForm.querySelectorAll('[name="required"]'),
      ];

      return (
        fieldsToValidate.length === 0 ||
        fieldsToValidate.find((field) => actionkit.forms.validate(field.value))
      );
    },
    decodeHTML: (html) => {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
  };

  window.wemove.utilities = utilities;
};
